import React from 'react';
import { useLocation } from 'react-router-dom';

const WA_PATH = 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z';

// Sticky bottom-left WhatsApp badge with circular "Share your query on WhatsApp" text.
export const WhatsAppSticky = () => {
  const { pathname } = useLocation();
  const hasMobileBar = pathname.startsWith('/villas/');
  const msg = encodeURIComponent(`Hi Royal Garden Villas, I have a query (from ${typeof window !== 'undefined' ? window.location.href : 'your website'})`);
  return (
    <a
      href={`https://wa.me/919820088292?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Share your query on WhatsApp"
      data-testid="whatsapp-sticky"
      className={`rgv-wa-sticky fixed left-3 md:left-5 z-50 w-[76px] h-[76px] md:w-[92px] md:h-[92px] ${hasMobileBar ? 'bottom-[84px] lg:bottom-5' : 'bottom-3 md:bottom-5'}`}
    >
      <span className="rgv-wa-ping absolute inset-[18%] rounded-full bg-[#25D366]" aria-hidden="true" />
      <svg viewBox="0 0 100 100" className="rgv-wa-ring absolute inset-0 w-full h-full" aria-hidden="true">
        <defs>
          <path id="rgv-wa-circle" d="M50,50 m-40,0 a40,40 0 1,1 80,0 a40,40 0 1,1 -80,0" />
        </defs>
        <circle cx="50" cy="50" r="48" fill="#ffffff" stroke="#25D366" strokeWidth="1.5" />
        <text fontSize="10.2" fontWeight="700" letterSpacing="0.9" fill="#128C7E" style={{ fontFamily: "'Manrope', system-ui, sans-serif" }}>
          <textPath href="#rgv-wa-circle" startOffset="0">SHARE YOUR QUERY ON WHATSAPP •</textPath>
        </text>
      </svg>
      <span className="rgv-wa-logo absolute inset-[27%] rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-green-600/40">
        <svg viewBox="0 0 24 24" className="w-[55%] h-[55%]" fill="currentColor" aria-hidden="true"><path d={WA_PATH} /></svg>
      </span>
    </a>
  );
};

export default WhatsAppSticky;
